import isInLazySearchExperiment from './isInLazySearchExperiment';

/**
 * Helper function to return "X-Client-Flights" header value to compose with
 * server flights
 */
export function getXClientFlightsHeaderValue(): string {
    if (isInLazySearchExperiment()) {
        return 'PeopleQTNoKqlClient';
    }

    // If user isn't in any flight, then no need to set header.
    return null;
}
